import { combineReducers } from 'redux'

import general from './general'
import specific from './specific'

const rootReducer = combineReducers({
	general,
	specific
})

export default rootReducer
